<template>
  <div class="section is-white has-text-centered is-transparent">
    <span class="icon">
      <font-awesome-icon icon="circle-notch" spin size="3x" color="#455F83" />
    </span>
  </div>
</template>

<script>
export default {
  name: "LoadingButton",
};
</script>

<style scoped></style>
